var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.385 0c-1.78 0-3.231 1.444-3.231 3.214S3.605 6.43 5.384 6.43c.337 0 .653-.067.96-.16-.101.067-.185.147-.278.227-.227-.03-.45-.067-.681-.067C2.419 6.429 0 8.835 0 11.786h1.077c0-2.281 1.78-4.119 4.038-4.26a4.772 4.772 0 0 0-.807 2.653C4.308 12.836 6.483 15 9.154 15 11.825 15 14 12.836 14 10.179c0-2.658-2.175-4.822-4.846-4.822-.614 0-1.195.126-1.738.335.724-.594 1.2-1.477 1.2-2.478C8.615 1.444 7.163 0 5.384 0zm0 1.071a2.142 2.142 0 1 1 0 4.286 2.142 2.142 0 1 1 0-4.286zM9.154 6.43a3.753 3.753 0 0 1 3.77 3.75 3.753 3.753 0 0 1-3.77 3.75 3.753 3.753 0 0 1-3.77-3.75 3.753 3.753 0 0 1 3.77-3.75zm-.539 3.214H6.462v1.071h5.384V9.643H8.615z",
    fill: "#485055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteClient);
export default __webpack_public_path__ + "static/media/deleteClient.ca57ad973287c0942ca427790b13319c.svg";
export { ForwardRef as ReactComponent };